<template lang="pug">
.form-work-with-us-wrap
  v-form.form-work-with-us(ref="form")
    v-select(
      :items="shops",
      :rules="[rules.required]",
      name="shop",
      label="Loja",
      background-color="white",
      color="primary",
      outlined,
      dense
    )
    v-text-field(
      :rules="[rules.required]",
      name="name",
      type="name",
      label="Nome",
      background-color="white",
      color="primary",
      outlined,
      dense
    )
    v-text-field(
      :rules="[rules.required, rules.email]",
      color="primary",
      name="email",
      type="email",
      label="E-mail",
      background-color="white",
      outlined,
      dense
    )
    v-text-field(
      v-mask="['(##) ####-####', '(##) #####-####']",
      :rules="[rules.required, rules.phone]",
      color="primary",
      outlined,
      dense,
      name="tel",
      type="tel",
      label="Telefone",
      background-color="white"
    )
    v-file-input(
      :rules="[rules.required]",
      color="primary",
      name="attachment",
      label="Anexar currículo",
      background-color="white",
      accept=".doc,.docx,application/msword,application/pdf",
      outlined,
      dense
    )
    v-btn.secondary.white--text(@click="submit", large, depressed) Enviar
    float-alert(:value="success", v-if="success", color="green") Sua mensagem foi enviada com sucesso.
    float-alert(:value="error", v-if="error", color="green") Aconteceu um erro ao enviar a mensagem.
  v-overlay(:value="loading")
    v-progress-circular(indeterminate, size="64")
</div>
</template>

<script>
import { mask } from "vue-the-mask";
import FloatAlert from "@/components/tools/FloatAlert";
import { required, email, phone } from "./rules";

export default {
  props: {
    action: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    rules: {
      required,
      email,
      phone,
    },
    loading: false,
    error: false,
    success: false,
  }),
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.error = false;
        this.success = false;

        fetch(this.action, {
          method: "POST",
          body: new FormData(this.$refs.form.$el),
        })
          .then((r) => {
            if (r.ok) this.success = true;
            else throw new Error(r.status);
          })
          .catch(() => (this.error = true))
          .finally(() => (this.loading = false));
      }
    },
  },
  computed: {
    shops() {
      return this.$rest("shops").list.map(({ id, title }) => ({
        text: title,
        value: id,
      }));
    },
  },
  directives: {
    mask,
  },
  beforeCreate() {
    this.$rest("shops").get();
  },
  components: {
    FloatAlert,
  },
};
</script>

<style>
.form-work-with-us-wrap {
  width: max-content;
}
.form-work-with-us {
  background: transparent;
  width: 100%;
  max-width: 400px;
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 10px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 7px;
}
@media screen and (min-width: 960px) {
  .form-work-with-us {
    grid-template-columns: 1fr 1fr;
  }
  .form-work-with-us :nth-child(5),
  .form-work-with-us :nth-child(6) {
    grid-column-end: span 2;
  }
}
.form-work-with-us .v-alert {
  margin-top: 16px;
  font-size: 18px;
}
@media screen and (max-width: 960px) {
  .form-work-with-us-wrap {
    width: 100%;
  }
}
</style>
